module.exports = __webpack_public_path__ + "static/media/usa.d3b540c5.jpg";